'use client';

import React from 'react';
import { NavBarSection } from '@/components/sections/NavBarSection';
import { FooterSection } from '@/components/sections/FooterSection';
import { HomeDataProvider } from '@/contexts/HomeDataContext';
import { homePageData } from '@/data/homePageData';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  showNavbar?: boolean;
  showFooter?: boolean;
  containerClassName?: string;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ 
  children, 
  className = "",
  showNavbar = true,
  showFooter = true,
  containerClassName = ""
}) => {
  return (
    <HomeDataProvider data={homePageData}>
      <div className={`min-h-screen bg-x-900 ${className}`}>
        {/* Navigation Bar */}
        {showNavbar && <NavBarSection />}
        
        {/* Page Content Container */}
        <main className={`relative ${containerClassName}`}>
          {children}
        </main>
        
        {/* Footer */}
        {showFooter && <FooterSection />}
      </div>
    </HomeDataProvider>
  );
};
